export interface ButtonTheme {
    importance?: 'primary' | 'secondary' | 'tertiary';
    size?: 'large' | 'normal' | 'small';
    readonly successOrError?: 'success' | 'error';
}

export enum TmButtonType {
    None = 'none',
    Submit = 'submit',
    Clear = 'clear',
    Reset = 'reset',
}
